import { render, staticRenderFns } from "./KnowledgeBaseLinkEditDialog.vue?vue&type=template&id=12fe0595&scoped=true"
import script from "./KnowledgeBaseLinkEditDialog.vue?vue&type=script&lang=js"
export * from "./KnowledgeBaseLinkEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fe0595",
  null
  
)

export default component.exports